import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

// Item 4 (toast redesign): top-center, floating just below the app's
// sticky header (StickyBar's BELOW_LOGO_BAR_STICKY offsets: top-20 on
// mobile, top-14 on desktop) rather than overlapping it, with a manual
// dismiss X on every toast. Per-severity color/icon is decided once in
// lib/toast.js's className/icon - only structural classes (radius, shadow,
// spacing) live here so there's no bg-*/border-* conflict between the two.
export const TOAST_POSITION = "top-center";
export const TOAST_OFFSET = { top: "5rem" };

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position={TOAST_POSITION}
      offset={TOAST_OFFSET}
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "group toast rounded-lg border shadow-md px-4 py-3 gap-3 items-start",
          title: "text-sm font-medium",
          description: "group-[.toast]:text-muted-foreground text-sm",
          closeButton: "opacity-70 hover:opacity-100",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
